(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ugc-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var SELECTOR = '[data-ugc-gallery]';
    var osReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var instances = new WeakMap();

    function qs(root, sel)  { return root.querySelector(sel); }
    function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

    function init(root) {
      if (instances.has(root)) return;

      var track = qs(root, '[data-ugc-track]');
      var wrap  = qs(root, '.ugc-gallery__track-wrap');
      if (!track) return;

      var duration    = parseFloat(root.dataset.duration) || 35;
      var autoplay    = root.dataset.autoplay === 'true';
      var forceMotion = root.dataset.forceMotion === 'true';
      var pauseHover  = root.dataset.pauseOnHover === 'true';
      var dragEnabled = root.dataset.drag === 'true';

      // If merchant forced autoplay, ignore OS reduced-motion preference for the track.
      // (Reveal animation still respects OS pref to avoid unnecessary motion.)
      var motionBlocked = osReducedMotion && !forceMotion;

      // Clone children once for seamless infinite loop
      var originals = Array.prototype.slice.call(track.children);
      originals.forEach(function (node) {
        var clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        qsa(clone, 'a, button, video').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
          if (el.tagName === 'A') el.setAttribute('aria-hidden', 'true');
        });
        track.appendChild(clone);
      });

      var loopWidth = 0;
      function measure() {
        var w = 0;
        var gapStr = window.getComputedStyle(track).gap || '0';
        var gap = parseFloat(gapStr) || 0;
        originals.forEach(function (node) { w += node.getBoundingClientRect().width; });
        w += gap * originals.length;
        loopWidth = w;
      }
      measure();
      if (window.requestAnimationFrame) {
        requestAnimationFrame(function () { requestAnimationFrame(measure); });
      }

      var offset = 0;
      var paused = false;
      var focused = false;
      var dragging = false;
      var dragCommitted = false;
      var dragStartX = 0;
      var dragStartY = 0;
      var dragStartOffset = 0;
      var raf = 0;
      var lastT = 0;

      function shouldAnimate() {
        return autoplay && !motionBlocked && !paused && !focused && !dragging;
      }

      function apply() {
        if (loopWidth > 0) {
          if (offset <= -loopWidth) offset += loopWidth;
          if (offset > 0) offset -= loopWidth;
        }
        track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
      }

      function tick(t) {
        if (!lastT) lastT = t;
        var dt = t - lastT;
        lastT = t;
        if (shouldAnimate() && loopWidth > 0) {
          var perMs = loopWidth / (duration * 1000);
          offset -= perMs * dt;
        }
        apply();
        raf = requestAnimationFrame(tick);
      }

      function onEnter() { if (pauseHover) paused = true; }
      function onLeave() { if (pauseHover) paused = false; }
      root.addEventListener('mouseenter', onEnter);
      root.addEventListener('mouseleave', onLeave);

      function onFocusIn(e) {
        if (e.target && e.target.closest && e.target.closest('.ugc-gallery__tile')) {
          focused = true;
        }
      }
      function onFocusOut(e) {
        if (!root.contains(e.relatedTarget)) focused = false;
      }
      root.addEventListener('focusin', onFocusIn);
      root.addEventListener('focusout', onFocusOut);

      function onPointerDown(e) {
        if (!dragEnabled) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragging = true;
        dragCommitted = false;
        dragStartX = e.clientX;
        dragStartY = e.clientY;
        dragStartOffset = offset;
        lastT = 0;
      }
      function onPointerMove(e) {
        if (!dragging) return;
        var dx = e.clientX - dragStartX;
        var dy = e.clientY - dragStartY;
        if (!dragCommitted) {
          if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
            dragCommitted = true;
            wrap.classList.add('is-dragging');
            try { wrap.setPointerCapture(e.pointerId); } catch (_) {}
          } else if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) {
            dragging = false;
            return;
          } else {
            return;
          }
        }
        offset = dragStartOffset + dx;
        apply();
        e.preventDefault();
      }
      function onPointerEnd(e) {
        if (!dragging) return;
        dragging = false;
        dragCommitted = false;
        wrap.classList.remove('is-dragging');
        try { wrap.releasePointerCapture(e.pointerId); } catch (_) {}
      }
      if (wrap) {
        wrap.addEventListener('pointerdown', onPointerDown);
        wrap.addEventListener('pointermove', onPointerMove);
        wrap.addEventListener('pointerup', onPointerEnd);
        wrap.addEventListener('pointercancel', onPointerEnd);
      }

      function onResize() { measure(); }
      window.addEventListener('resize', onResize);

      // Reveal — always respects OS reduced-motion (no force-override for reveal).
      var revealIO = null;
      if (!osReducedMotion && 'IntersectionObserver' in window) {
        root.classList.add('ugc-gallery--js');
        revealIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.add('is-revealed');
              revealIO.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
        revealIO.observe(root);
      }

      // Video tiles — play in view, pause out; skip entirely if motion is blocked.
      var videoIO = null;
      var videos = qsa(track, '[data-ugc-video]');
      if (!motionBlocked && 'IntersectionObserver' in window && videos.length) {
        videoIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting) {
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              v.pause();
            }
          });
        }, { threshold: 0.1 });
        videos.forEach(function (v) { videoIO.observe(v); });
      }

      raf = requestAnimationFrame(tick);

      instances.set(root, function cleanup() {
        cancelAnimationFrame(raf);
        window.removeEventListener('resize', onResize);
        root.removeEventListener('mouseenter', onEnter);
        root.removeEventListener('mouseleave', onLeave);
        root.removeEventListener('focusin', onFocusIn);
        root.removeEventListener('focusout', onFocusOut);
        if (wrap) {
          wrap.removeEventListener('pointerdown', onPointerDown);
          wrap.removeEventListener('pointermove', onPointerMove);
          wrap.removeEventListener('pointerup', onPointerEnd);
          wrap.removeEventListener('pointercancel', onPointerEnd);
        }
        if (revealIO) revealIO.disconnect();
        if (videoIO)  videoIO.disconnect();
      });
    }

    function initAll(scope) {
      var parent = scope || document;
      var roots;
      if (parent.matches && parent.matches(SELECTOR)) {
        roots = [parent];
      } else {
        roots = qsa(parent, SELECTOR);
      }
      roots.forEach(init);
    }

    function destroy(scope) {
      var parent = scope || document;
      var roots;
      if (parent.matches && parent.matches(SELECTOR)) {
        roots = [parent];
      } else {
        roots = qsa(parent, SELECTOR);
      }
      roots.forEach(function (root) {
        var fn = instances.get(root);
        if (fn) { fn(); instances.delete(root); }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
